'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Survey = void 0;
var $ = require("jquery");
var Survey = /** @class */ (function () {
    function Survey() {
        var _this = this;
        this.OVER_PC_WIDTH = 1200;
        this.OVER_SP_WIDTH = 600;
        this.HEADER_HEIGHT = 150;
        var self = this;
        if ($('#trigSurveySubmit').length > 0) {
            document.getElementById('trigSurveySubmit').addEventListener('click', function (e) {
                // e.preventDefault();
                $('.bulletSurveyValidate').removeClass('has-error');
                var values = _this.getValues();
                return _this.validates(values, e);
            });
        }
    }
    Survey.prototype.getValues = function () {
        var values = {};
        var elms;
        elms = $('input[type="text"]');
        values = this.getTextValues(elms, values);
        elms = $('textarea');
        values = this.getTextValues(elms, values);
        elms = $('input[type="radio"]');
        values = this.getRadioValues(elms, values);
        elms = $('input[type="checkbox"]');
        values = this.getCheckboxValues(elms, values);
        elms = $('select');
        values = this.getSelectValues(elms, values);
        return values;
    };
    // テキストタイプ
    Survey.prototype.getTextValues = function (elms, values) {
        var elm;
        var category, number, must;
        for (var i = 0; i < elms.length; i++) {
            elm = elms.eq(i);
            category = elm.data('category');
            number = elm.data('number');
            must = elm.data('must');
            if (values[category] == undefined) {
                values[category] = {};
            }
            values[category][number] = {
                val: elm.val(),
                must: must,
            };
        }
        return values;
    };
    // Radioタイプ
    Survey.prototype.getRadioValues = function (elms, values) {
        var elm;
        var category, number, must;
        for (var i = 0; i < elms.length; i++) {
            elm = elms.eq(i);
            category = elm.data('category');
            number = elm.data('number');
            must = elm.data('must');
            if (values[category] == undefined) {
                values[category] = {};
            }
            if (values[category][number] == undefined) {
                values[category][number] = { val: '', must: '' };
            }
            if (elm.is(':checked')) {
                values[category][number]['val'] = elm.val();
            }
            if (elm.data('must')) {
                values[category][number]['must'] = 1;
            }
        }
        return values;
    };
    // Selectタイプ
    Survey.prototype.getSelectValues = function (elms, values) {
        var elm;
        var category, number, must;
        for (var i = 0; i < elms.length; i++) {
            elm = elms.eq(i);
            category = elm.data('category');
            number = elm.data('number');
            must = elm.data('must');
            if (values[category] == undefined) {
                values[category] = {};
            }
            values[category][number] = {
                val: elm.val(),
                must: must,
            };
        }
        return values;
    };
    // Checkboxタイプ
    Survey.prototype.getCheckboxValues = function (elms, values) {
        var elm;
        var category, number, must;
        for (var i = 0; i < elms.length; i++) {
            elm = elms.eq(i);
            category = elm.data('category');
            number = elm.data('number');
            must = elm.data('must');
            if (values[category] == undefined) {
                values[category] = {};
            }
            if (values[category][number] == undefined) {
                values[category][number] = { val: [], must: '' };
            }
            if (elm.is(':checked')) {
                values[category][number]['val'].push(elm.val());
            }
            if (elm.data('must')) {
                values[category][number]['must'] = 1;
            }
        }
        return values;
    };
    Survey.prototype.validates = function (values, e) {
        var errorFlag = false;
        // let scrollToNames = [];
        // console.log(values);
        // 空白チェック
        var value = {
            must: undefined,
            val: undefined
        };
        var numbers = {};
        var hasAnError = false;
        Object.keys(values).forEach(function (categoryCode) {
            numbers = values[categoryCode];
            Object.keys(numbers).forEach(function (numberString) {
                value = numbers[numberString];
                hasAnError = false;
                if (value.must == 1) {
                    if (typeof value.val == 'object' && value.val.length == 0) {
                        errorFlag = true;
                        hasAnError = true;
                    }
                    else if (value.val == '') {
                        errorFlag = true;
                        hasAnError = true;
                    }
                }
                if (hasAnError) {
                    $('.bulletSurveyValidate[data-category="' + categoryCode + '"][data-number="' + numberString + '"]').addClass('has-error');
                    // scrollToNames.push( {category: categoryCode, number: numberString} );
                }
            });
        });
        // エラー時処理
        if (errorFlag) {
            var formPosition = $('#survey').offset().top;
            $('html, body').animate({
                scrollTop: formPosition
            }, 'slow');
            e.preventDefault();
            return false;
        }
    };
    return Survey;
}());
exports.Survey = Survey;
exports.default = Survey;
